"use client";

import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { DZTypes } from "@dealerzone/libs";
import InventoryFilters from "./InventoryFilters";

interface MobileFilterButtonProps {
  makes: DZTypes.Make[];
  locations: DZTypes.Location[];
  filters: DZTypes.DealerFilter[];
  currentParams: { [key: string]: string | string[] | undefined };
}

export default function MobileFilterButton({ makes, locations, filters, currentParams }: MobileFilterButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="lg:hidden flex items-center gap-2 px-4 py-2 bg-white hover:bg-zinc-50 text-zinc-900 border border-zinc-900 rounded-lg transition-colors font-medium"
      >
        <i className="bootstrap-funnel"></i>
        <span>Filters</span>
      </button>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50 lg:hidden">
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

        <div className="fixed inset-0 flex justify-end">
          <Dialog.Panel className="w-full max-w-xs bg-white h-full overflow-y-auto shadow-xl">
            <div className="sticky top-0 bg-white border-b border-zinc-200 px-4 py-3 flex items-center justify-between">
              <Dialog.Title className="font-semibold text-zinc-900">Filters</Dialog.Title>
              <button
                onClick={() => setIsOpen(false)}
                className="text-zinc-400 hover:text-zinc-600"
              >
                <i className="bootstrap-x-lg text-lg"></i>
              </button>
            </div>

            <div className="p-4">
              <InventoryFilters
                makes={makes}
                locations={locations}
                filters={filters}
                currentParams={currentParams}
              />
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}
